import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, mergeMap, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
    constructor(private auth: AuthService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.auth.userInfo$.pipe(
            take(1),
            mergeMap((userInfo) => {
                if (!userInfo.isLoggedIn) {
                    return next.handle(req);
                }
                return this.auth.getTokenSilently$().pipe(
                    mergeMap((token) => {
                        const tokenReq = req.clone({
                            setHeaders: { Authorization: `Bearer ${token}` }
                        });
                        return next.handle(tokenReq);
                    }),
                    catchError((err) => throwError(err))
                );
            })
        );
    }
}
